import { BrowserRouter, Routes, Route, Navigate, useSearchParams } from 'react-router-dom';
import { HomePage } from './pages/HomePage.js';
import { ScanPage } from './pages/ScanPage.js';
import { ViewerPage } from './pages/ViewerPage.js';
import { ProjetoPage } from './pages/ProjetoPage.js';
import { ThemeToggle } from './components/ThemeToggle.js';
import { PasswordGate } from './components/PasswordGate.js';

// Viewer: se veio pelo QR (tem ?peca=) libera sem senha, mas só aquele móvel.
// Aberto por ?movel= (lista/voltar) exige a senha do dia.
function ViewerGate() {
  const [p] = useSearchParams();
  return (
    <PasswordGate bypass={!!p.get('peca')}>
      <ViewerPage />
    </PasswordGate>
  );
}

export function App() {
  return (
    <BrowserRouter>
      <ThemeToggle />
      <Routes>
        <Route path="/" element={<PasswordGate><HomePage /></PasswordGate>} />
        <Route path="/scan" element={<ScanPage />} />
        <Route path="/v" element={<ViewerGate />} />
        <Route path="/projeto" element={<PasswordGate><ProjetoPage /></PasswordGate>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
